/**
 * @author Peter Kelley
 * @author pgkelley4@gmail.com
 */
/**
 * See if two line segments intersect. This uses the
 * vector cross product approach described below:
 * http://stackoverflow.com/a/565282/786339
 *
 * @param {Object} sLine point object with x and y coordinates
 *  representing the start of the 1st line.
 * @param {Object} eLine point object with x and y coordinates
 *  representing the end of the 1st line.
 * @param {Object} sSegment point object with x and y coordinates
 *  representing the start of the 2nd line.
 * @param {Object} eSegment point object with x and y coordinates
 *  representing the end of the 2nd line.
 */
export function lineSegmentIntersection(sLine, eLine, sSegment, eSegment) {
    const lineVec /* r */ = eLine.subtract(sLine);
    const segmentVec /* s */ = eSegment.subtract(sSegment);
    const sSegmentLine = sSegment.subtract(sLine);
    const uNumerator = sSegmentLine.cross(lineVec);
    const denominator = lineVec.cross(segmentVec);
    if (uNumerator === 0 && denominator === 0) {
        // They are coLlinear
        return null;
        // Do they touch? (Are any of the points equal?)
        // if (
        //   equalPoints(p, q) ||
        //   equalPoints(p, q2) ||
        //   equalPoints(p2, q) ||
        //   equalPoints(p2, q2)
        // ) {
        //   return null;
        // }
        // // Do they overlap? (Are all the point differences in either direction the same sign)
        // const doTheyOverlap = !allEqual(
        //   q.x - p.x < 0,
        //   q.x - p2.x < 0,
        //   q2.x - p.x < 0,
        //   q2.x - p2.x < 0
        // ) ||
        // !allEqual(q.y - p.y < 0, q.y - p2.y < 0, q2.y - p.y < 0, q2.y - p2.y < 0);
        // if(!doTheyOverlap) {
        // }
        // return (
        // );
    }
    if (denominator === 0) {
        // lines are paralell
        return null;
    }
    const up = uNumerator / denominator;
    const tp = sSegmentLine.cross(segmentVec) / denominator;
    const doIntersect = tp >= 0 && tp <= 1 && up >= 0 && up <= 1;
    if (!doIntersect) {
        return null;
    }
    return {
        x: sLine.x + tp * lineVec.x,
        y: sLine.y + tp * lineVec.y,
    };
}
